var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({class:_vm.badgeClassObject,attrs:{"data-samora":""}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.valueToDisplay)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }